import AppStoreSvg from "../../Assets/appStoreDark.svg";
import styles from "./Home.module.scss";

export interface DownloadOnAppStoreButtonProps {
  /** Additional styles to apply to the button. */
  style?: React.CSSProperties;
}

/**
 * A button that opens the App Store and navigates to the ChiGo app page.
 */
export function DownloadOnAppStoreButton({
  style,
}: DownloadOnAppStoreButtonProps) {
  return (
    <a
      href="https://apps.apple.com/us/app/chigo-chicago-trains-buses/id6739185774"
      role="button"
      style={style}
    >
      <img
        className={styles["prevent-text-selection"]}
        style={{ width: 175 }}
        src={AppStoreSvg}
        onClick={() =>
          window.open(
            "https://apps.apple.com/us/app/chigo-chicago-trains-buses/id6739185774",
            "_blank"
          )
        }
        alt="Download on the App Store"
      />
    </a>
  );
}
